/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type NotificationRuleAssetSelectionDto = {
    type: NotificationRuleAssetSelectionDto.type;
};

export namespace NotificationRuleAssetSelectionDto {

    export enum type {
        ALL = 'ALL',
        DYNAMIC = 'DYNAMIC',
        STATIC = 'STATIC',
    }


}
